let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aOVJ4")).then(() => parcelRequire('fexWs'));